module.exports = __webpack_public_path__ + "img/form-settings-image-position.a0075e99.svg";